import { formatDateForDisplay } from '@/lib/utils';
import {
  ContainerCountChartResponse,
  ContainerTeuChartResponse,
  SimulationRunContainerCountData,
  SimulationRunContainerTeuData,
} from '@/routes/(app)/(scenarios)/(simulation)/simulation.types';

export interface MapContainerCountChartDataOptions {
  data: SimulationRunContainerCountData;
  showRegular: boolean;
  showReefer: boolean;
}

export function mapContainerCountChartData({
  data,
  showRegular,
  showReefer,
}: MapContainerCountChartDataOptions): ContainerCountChartResponse {
  return data.data.map((item) => {
    const regularMask = Number(showRegular);
    const reeferMask = Number(showReefer);
    return {
      date: formatDateForDisplay(item.shift_datetime),
      total: {
        import:
          (item.regular.import ?? 0) * regularMask +
          (item.reefer.import ?? 0) * reeferMask,
        export:
          (item.regular.export ?? 0) * regularMask +
          (item.reefer.export ?? 0) * reeferMask,
        transshipment:
          (item.regular.transshipment ?? 0) * regularMask +
          (item.reefer.transshipment ?? 0) * reeferMask,
      },
      incoming: {
        import:
          (item.regular.import ?? 0) * regularMask +
          (item.reefer.import ?? 0) * reeferMask,
        export: 0,
        transshipment: 0,
      },
      outgoing: {
        import: 0,
        export:
          (item.regular.export ?? 0) * regularMask +
          (item.reefer.export ?? 0) * reeferMask,
        transshipment:
          (item.regular.transshipment ?? 0) * regularMask +
          (item.reefer.transshipment ?? 0) * reeferMask,
      },
    };
  });
}

export function mapContainerTeuChartData(
  data: SimulationRunContainerTeuData
): ContainerTeuChartResponse {
  return data.data.map((item) => ({
    date: formatDateForDisplay(item.shift_datetime),
    teu: {
      import: item.import_containers,
      export: item.export_containers,
      transshipment: item.transshipment_containers,
    },
  }));
}
